import { useSelector } from 'react-redux'
import { CampaignTypes } from '../../Codes'

const AdGroupAdvancedOptionsSummary = () => {
  const {
    campaign: {
      form: { campaignType },
    },
    adGroup: {
      form: {
        mobileWeight,
        pcWeight,
        keywordExtensionWeight,
        contentMatchingMaxBiddingAmount,
        customContentMatchingMaxBiddingAmountYn,
        startDate,
        endDate,
        endDateDisabled,
      },
    },
  } = useSelector(state => state.ad)
  return (
    <p className="desc_box">
      {campaignType === CampaignTypes.PREMIUM_LINK && (
        <>
          <strong>입찰가중치</strong> - 디바이스(모바일 {mobileWeight}%, PC{' '}
          {pcWeight}
          %), 키워드 확장({keywordExtensionWeight}%) /{' '}
          <strong>콘텐츠 매체 입찰가</strong> -{' '}
          {customContentMatchingMaxBiddingAmountYn === 'N'
            ? '미설정'
            : `${contentMatchingMaxBiddingAmount.toLocaleString()}원`}{' '}
          /{' '}
        </>
      )}
      <strong>집행기간</strong> - {startDate?.replaceAll('-', '.')}~
      {endDateDisabled ? '미설정' : endDate?.replaceAll('-', '.')}
    </p>
  )
}
export default AdGroupAdvancedOptionsSummary
